import { base64urlEncode } from '@bigmi/core';
export function createUnsecuredToken(payload) {
    const header = { typ: 'JWT', alg: 'none' };
    const encodedHeader = base64urlEncode(JSON.stringify(header));
    const encodedPayload = base64urlEncode(JSON.stringify(payload));
    return `${encodedHeader}.${encodedPayload}.`;
}
//# sourceMappingURL=createUnsecuredToken.js.map